import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectRemoteStethoscope,
  unselectRemoteStethoscope,
} from "../actions/creators";
export default function useTileControls() {
  const compositorTiles = useSelector((state) => state.call.compositorTiles);
  const { remoteStethoscopes = [], selectedRemoteStethoscope } = useSelector(
    (state) => state.feature_stethoscope
  );
  const dispatch = useDispatch();

  useEffect(() => {
    compositorTiles.forEach(({ element, isApplication, participantId }) => {
      if (isApplication) {
        return;
      }
      const tileControls = element.querySelector(".video-tile-controls");

      if (tileControls) {
        const stethoscope = remoteStethoscopes.find(
          (microphone) => microphone.participant.id === participantId
        );
        const stethoscopeControl = tileControls.querySelector(
          ".tile-control.stethoscope"
        );

        const stethoscopeImg = `
          <svg role="img" aria-label="Stethoscope" width="16px" height="16px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
            <g transform="matrix(0.796708,0,0,0.800636,0.7257,-0.601288)">
              <path d="M29.01,22.338L29.01,22.161C29.01,21.665 28.574,21.261 28.038,21.261L27.895,21.261C27.359,21.261 26.923,21.665 26.923,22.161L26.923,22.338L25.293,22.338L25.293,26.17C25.293,26.852 25.893,27.407 26.63,27.407L26.944,27.407L26.91,31.624L26.91,31.711L26.909,31.969L26.909,32.065C26.894,32.164 26.828,32.404 26.546,32.769C25.765,33.775 23.995,34.908 21.952,35.015C19.594,35.141 17.661,33.833 16.722,32.675C16.15,31.971 16.102,31.511 16.118,31.441L16.097,31.077L16.097,23.11C16.703,23.033 17.303,22.895 17.831,22.769C20.475,22.135 22.94,19.439 24.263,15.735C25.713,11.672 27.271,6.028 24.063,3.927C23.282,3.414 22.567,2.841 20.781,2.889C20.386,2.336 19.72,2 18.991,2C17.808,2 16.844,2.891 16.844,3.986C16.844,5.081 17.808,5.972 18.991,5.972C19.902,5.972 20.692,5.455 21.001,4.686C22.108,4.689 22.377,5.026 22.94,5.394C23.827,5.976 24.165,7.289 23.947,9.299C23.725,11.341 22.967,13.628 22.416,15.171C21.316,18.254 19.324,20.553 17.343,21.028C16.789,21.161 16.372,21.247 16.018,21.301C16.018,21.301 15.299,21.372 15.11,21.375L15.094,21.375C14.9,21.372 14.183,21.301 14.183,21.301C13.829,21.247 13.412,21.161 12.858,21.028C10.876,20.553 8.885,18.254 7.784,15.171C7.234,13.628 6.476,11.342 6.254,9.299C6.035,7.289 6.374,5.976 7.261,5.394C7.824,5.026 8.093,4.689 9.199,4.686C9.509,5.455 10.299,5.972 11.209,5.972C12.393,5.972 13.356,5.081 13.356,3.986C13.356,2.891 12.393,2 11.209,2C10.481,2 9.815,2.336 9.419,2.889C7.634,2.843 6.919,3.414 6.137,3.927C4.693,4.873 4.072,6.646 4.294,9.197C4.492,11.485 5.327,14.024 5.938,15.735C7.261,19.439 9.725,22.135 12.37,22.769C12.968,22.912 13.486,23.025 13.991,23.096L13.991,32.154C14.14,32.697 14.575,33.275 15.037,33.845C16.208,35.288 18.641,36.972 21.644,36.972C21.785,36.972 21.929,36.968 22.072,36.961C24.806,36.817 27.195,35.275 28.258,33.904C28.586,33.48 28.81,33.061 28.927,32.654L28.973,32.475L29.015,32.184C29.023,32.082 29.023,31.977 29.016,31.873L29.051,27.407L29.141,27.407C29.878,27.407 30.478,26.852 30.478,26.17L30.478,22.338L29.01,22.338Z" style="fill:white;"/>
            </g>
          </svg>`;

        if (stethoscope) {
          let control = stethoscopeControl;

          if (!control) {
            control = document.createElement("div");
            control.className = "tile-control stethoscope";
            control.innerHTML = stethoscopeImg;
            tileControls.insertBefore(
              control,
              tileControls.firstElementChild.nextElementSibling
            );
          }

          control.onclick = () => {
            if (stethoscope.id !== selectedRemoteStethoscope?.id) {
              dispatch(selectRemoteStethoscope(stethoscope));
            } else {
              dispatch(unselectRemoteStethoscope());
            }
          };
        } else if (stethoscopeControl && !stethoscope) {
          stethoscopeControl.remove();
        }
      }
    });
  }, [
    compositorTiles,
    remoteStethoscopes,
    selectedRemoteStethoscope,
    dispatch,
  ]);
}
